import { createApp } from 'vue'
import App from '@/core/app'

const mainApp = createApp(App)

mainApp.mount("#app")